
import { Button, Modal, Input, Form, Select, message, Col, Row, DatePicker } from 'antd';
import React, { useState, useEffect } from 'react';
import axios from 'axios';

import { requestError } from '../../controllers/functions';

const SchoolSenderId = ({ show, setOpenModal, record, refresh }) => {

  const [form] = Form.useForm();

  const [isModalVisible, setIsModalVisible] = useState(false);

  useEffect(() => {
    // form.setFieldValue('smsSenderId', record?.smsSenderId );
    form.setFieldsValue(record);
  }, [form, record, show]);

  if(show !== isModalVisible){
    setIsModalVisible(show);
  }

  const extractTokenFromUrl = () =>{
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    return urlParams.get('token');
}

  const submit = (v) =>{
    axios.put(process.env.REACT_APP_API_URI+`/schools/sender/id/${record?.id}`, v , {headers: { authorization : `Bearer ${extractTokenFromUrl()}`}} ).then(res=>{
      message.success(res.data.res)
      setOpenModal(false);
      refresh();
    }).catch(error=>{
      requestError({error});
    }).finally(done=>{
        setLoading(false);
    })
  }

  const [loading, setLoading] = useState(false)

  return (
    <>
    
      <Modal 
      title={`SMS SENDER ID ${record?.name}`.toUpperCase() }
      open={isModalVisible} 
      onOk={()=>setOpenModal(false)} 
      onCancel={()=>setOpenModal(false)}
      footer={[
        <Button key="cancel" type=""  onClick={()=>{setOpenModal(false)}}>
            Cancel
        </Button>,
        <Button  key="submit" type="primary" htmlType="submit" form="schoolSenderID" loading={loading}>
          Submit
        </Button>     
      ]}
      >
      <Form
      layout="vertical"
      className="row-col"
      onFinish={submit}
      id="schoolSenderID" 
      form={form}
      >

        <Row>

          <Col xs={24} sm={24} md={12} lg={12} >
            <Form.Item
            label = "SMS Sender ID"
            name = "smsSenderId" 
            style={{marginRight: 5}}>
              <Input style={{ height : 32 }} placeholder="Sms Sender ID" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={12} lg={12} >
            <Form.Item
            name = "organizationId" 
            label = "Organization ID" 
            style={{marginRight: 5}}>
                <Input type="number"    style={{ height : 32 }} name = "organizationId" placeholder="School organization" />
            </Form.Item>
          </Col>

          <Col span={12} >
            <Form.Item
            name = "pricePerSmsEconet" 
            label = "Econet SMS Price" 
            style={{marginRight: 5}}>
                <Input type="number"    style={{ height : 32 }} name = "pricePerSmsEconet" placeholder="Econet SMS Price" />
            </Form.Item>
          </Col>
          
          <Col span={12} >
            <Form.Item
            name = "pricePerSmsNetone" 
            label = "NetOne SMS Price" 
            style={{marginRight: 5}}>
                <Input type="number"    style={{ height : 32 }} name = "pricePerSmsNetone" placeholder="NetOne SMS Price" />
            </Form.Item>
          </Col>

        </Row>
        </Form>
      </Modal>
    </>
  );
};

export default SchoolSenderId;